import { render, staticRenderFns } from "./Transporte.vue?vue&type=template&id=6ae3e498"
import script from "./Transporte.vue?vue&type=script&lang=js"
export * from "./Transporte.vue?vue&type=script&lang=js"
import style0 from "./Transporte.vue?vue&type=style&index=0&id=6ae3e498&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports